module.exports = __webpack_public_path__ + "img/step-1.c42312d5.jpg";